module.exports = __webpack_public_path__ + "img/suipian_top.63214778.png";